import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "editEmailAlumniComplete",
  tabindex: "-1",
  "aria-labelledby": "editEmailAlumniComplete",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_6 = { class: "text-center my-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_9 = { class: "d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  resetFormEmail: Function as PropType<() => void | any>,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('SE45resetEmail')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.resetFormEmail && __props.resetFormEmail(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString(_unref(translate)('SE46description1')), 1),
          _hoisted_7,
          _createTextVNode(_toDisplayString(_unref(translate)('SE46description2')), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              onClick: __props.resetFormEmail
            }, null, 8, ["title", "onClick"])
          ])
        ])
      ])
    ])
  ]))
}
}

})